"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_1 = require("../graphql");
exports.AWESOME_RESOURCE_CONFIG = {
    ad: {
        // getLink: obj => {
        //   return `/ads/${obj.id}`;
        // },
        resourceName: 'ad',
        resourceNamePlural: 'ads',
        selectProps: {
            paths: {
                count: 'adsCount',
                label: 'name',
                list: 'ads',
                value: 'id',
            },
            query: graphql_1.ads,
        },
    },
    contentConversion: {
        // getLink: obj => {
        //   return `/templates/${obj.contentSystem.id}/conversions/${obj.id}`;
        // },
        resourceName: 'contentConversion',
        resourceNamePlural: 'contentConversions',
        selectProps: {
            paths: {
                count: 'contentConversionsCount',
                label: 'name',
                list: 'contentConversions',
                value: 'id',
            },
            query: graphql_1.contentConversions,
        },
    },
    contentFeed: {
        // getLink: obj => {
        //   return `/integrations/${obj?.contentSystem?.id}/feeds/${obj?.id}`;
        // },
        resourceName: 'contentFeed',
        resourceNamePlural: 'contentFeeds',
        selectProps: {
            paths: {
                count: 'contentFeedsCount',
                label: 'name',
                list: 'contentFeeds',
                value: 'id',
            },
            query: graphql_1.contentFeedsList,
        },
    },
    contentMapping: {
        // getLink: obj => {
        //   return `/integrations/${obj.contentSystem?.id}/mappings/${obj.id}`;
        // },
        resourceName: 'contentMapping',
        resourceNamePlural: 'contentMappings',
        selectProps: {
            paths: {
                count: 'contentMappingsCount',
                label: 'name',
                list: 'contentMappings',
                value: 'id',
            },
            query: graphql_1.contentMappingsList,
        },
    },
    context: {
        // getLink: obj => {
        //   return `/contexts/conversions/${obj.id}`;
        // },
        resourceName: 'context',
        resourceNamePlural: 'contexts',
        selectProps: {
            paths: {
                count: 'contextsCount',
                label: 'name',
                list: 'contexts',
                value: 'id',
            },
            query: graphql_1.contexts,
        },
    },
    emailList: {
        // getLink: obj => {
        //   return `/lists/${obj.id}`;
        // },
        resourceName: 'emailList',
        resourceNamePlural: 'emailLists',
        selectProps: {
            paths: {
                count: 'emailListsCount',
                label: 'name',
                list: 'emailLists',
                value: 'id/espId',
            },
            query: graphql_1.emailLists,
        },
    },
    emailSegment: {
        // getLink: obj => {
        //   return `/lists/${obj.id}`;
        // },
        resourceName: 'emailSegment',
        resourceNamePlural: 'emailListSegments',
        selectProps: {
            paths: {
                count: 'emailSegmentsCount',
                label: 'name',
                list: 'emailSegments',
                value: 'id/espId',
            },
            query: graphql_1.emailSegments,
        },
    },
    email: {
        // getLink: obj => {
        //   return `/templates/${obj.id}`;
        // },
        resourceName: 'email',
        resourceNamePlural: 'email',
        selectProps: {
            paths: {
                count: 'emailsCount',
                label: 'name',
                list: 'emails',
                value: 'id',
            },
            query: graphql_1.emails,
        },
    },
    emailTemplate: {
        // getLink: obj => {
        //   return `/templates/${obj.id}`;
        // },
        resourceName: 'emailTemplate',
        resourceNamePlural: 'emailTemplates',
        selectProps: {
            paths: {
                count: 'emailTemplatesCount',
                label: 'name',
                list: 'emailTemplates',
                value: 'id',
            },
            query: graphql_1.emailTemplates,
        },
    },
    emailTemplateVersion: {
        // getLink: obj => {
        //   return `/templates/${obj.template.id}/versions/${obj.id}`;
        // },
        resourceName: 'emailTemplateVersion',
        resourceNamePlural: 'emailTemplateVersions',
        selectProps: {
            paths: {
                count: 'emailTemplateVersionsCount',
                label: 'version',
                list: 'emailTemplateVersions',
                value: 'id',
            },
            query: graphql_1.emailTemplateVersions,
        },
    },
    integration: {
        // getLink: obj => {
        //   return `/integrations/${obj.id}`;
        // },
        resourceName: 'integration',
        resourceNamePlural: 'integrations',
        selectProps: {
            paths: {
                count: 'integrationsCount',
                label: 'name',
                list: 'integrations',
                value: 'id',
            },
            query: graphql_1.integrations,
        },
    },
    user: {
        // getLink: obj => {
        //   return `/users/${obj.id}`;
        // },
        resourceName: 'user',
        resourceNamePlural: 'users',
        selectProps: {
            paths: {
                count: 'usersCount',
                label: 'fullName/email',
                list: 'users',
                value: 'id',
            },
            query: graphql_1.users,
        },
    },
    workspace: {
        // getLink: obj => {
        //   return `/admin/workspaces/${obj.id}`;
        // },
        resourceName: 'workspace',
        resourceNamePlural: 'workspaces',
        selectProps: {
            paths: {
                count: 'workspacesCount',
                label: 'name',
                list: 'workspaces',
                value: 'id',
            },
            query: graphql_1.workspaces,
        },
    },
};
//# sourceMappingURL=constants.js.map